import { useDeleteSoftwareLicenceMutation } from "@sso/apis/softwareLicences";
import { useGetSoftwareLicenceById } from "@sso/apis/softwareLicences/hooks";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../../components";

const LicenceTypeDelete = () => {
  const { id } = useAppSelector(selectDialog);
  const sl = useGetSoftwareLicenceById(id?.toString());
  const [deleteSoftwareLicence, { isLoading }] = useDeleteSoftwareLicenceMutation();

  const handleDeleteAction = () => {
    if (!id || !sl) {
      return;
    }
    deleteSoftwareLicence(id.toString());
  };

  return (
    <>
      <DialogHeader title={DialogTitle.DELETE_LICENCE_TYPE} />
      <DialogBody>
        <Typography display="initial">
          Are you sure to delete this Licence type?
          <br />
          <br />
          <small>{sl ? `Name: ${sl.name}` : "Error finding the Licence type"}</small>
        </Typography>
      </DialogBody>
      <DialogActionButtons loading={isLoading} buttonTitle={"Delete"} onClickAction={handleDeleteAction} />
    </>
  );
};

export default LicenceTypeDelete;
